var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRecent = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1054_1772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2959 7.5V12L16.0459 14.25",
    stroke: "#667F93",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5459 9.75H21.2959V6",
    stroke: "#667F93",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9579 18.0004C16.7785 19.1132 15.2974 19.8538 13.6996 20.1297C12.1017 20.4056 10.458 20.2045 8.97374 19.5515C7.48951 18.8986 6.23061 17.8227 5.35434 16.4584C4.47806 15.0941 4.02326 13.5017 4.04677 11.8804C4.07027 10.2591 4.57104 8.68062 5.4865 7.34226C6.40196 6.0039 7.69151 4.96499 9.19404 4.35533C10.6966 3.74568 12.3454 3.59231 13.9346 3.9144C15.5238 4.23648 16.9829 5.01974 18.1295 6.1663C19.2329 7.2838 20.1441 8.33755 21.2954 9.75036",
    stroke: "#667F93",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1054_1772"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRecent);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/recent.72750b548612b09506833ca6ff2e22da.svg";